import {FC, TextareaHTMLAttributes, useEffect, useRef, useState} from "react";

export type AutoResizeTextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {};

export const AutoResizeTextarea: FC<AutoResizeTextareaProps> = (props) => {
  const {
    style: propsStyle = {},
    value,
  } = props;
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [height, setHeight] = useState<number>(32);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      setHeight(textareaRef.current.scrollHeight);
    }
  }, [value]);

  return (
    <textarea
      {...props}
      ref={textareaRef}
      style={{
        ...propsStyle,
        height: `${height}px`,
      }}
    />
  );
};
